import React from "react";
import Modal from "./Modal";

function AppModal(props){

    return (
        <Modal type={props.type} uncloseable={props.uncloseable} transparentBackdrop={props.transparentBackdrop} modalHeader={props.modalHeader} isMobile={props.isMobile} onClose={props.closeFunction} >
            {props.modalContent}
        </Modal>
    )
}

export default AppModal;